export const ShippingMethodsTableColumns = [
    {
        id: "name",
        labelEn: "Name",
        labelAr: "الاسم",
        align: "left",
        sortable: true,
    },
    {
        id: "type",
        labelEn: "Type",
        labelAr: "النوع",
        align: "center",
        sortable: false,
    },
    {
        id: "price",
        labelEn: "Price",
        labelAr: "السعر",
        align: "center",
        sortable: false,
    },
    {
        id: "weight_range",
        labelEn: "Weight (g)",
        labelAr: "الوزن (جم)",
        align: "center",
        sortable: false,
    },
    {
        id: "zone",
        labelEn: "Zone",
        labelAr: "المنطقة",
        align: "center",
        sortable: false,
    },
    {
        id: "is_active",
        labelEn: "Active",
        labelAr: "نشط",
        align: "center",
        sortable: false,
    },
];
